import SectionTitle from "../common/SectionTitle";
import {
  ShieldCheck,
  FileText,
  Link2,
  Gavel,
  Globe2,
  AlertCircle,
  Zap,
} from "lucide-react";

const terms = [
  {
    id: "acceptance",
    title: "Acceptance of Terms",
    icon: ShieldCheck,
    desc: `By accessing or using this Service, you agree to be bound by these Terms and Conditions.`,
  },
  {
    id: "definitions",
    title: "Interpretation & Definitions",
    icon: FileText,
    desc: `Words with capitalized letters have meanings defined in this document. These definitions apply regardless of whether they are used in singular or plural form.`,
  },
  {
    id: "acknowledgment",
    title: "Acknowledgment",
    icon: ShieldCheck,
    desc: `These Terms govern your use of the Service. You must be 18+ to use the Service. Your access is conditioned on acceptance of these Terms and our Privacy Policy.`,
  },
  {
    id: "links",
    title: "Links to Other Websites",
    icon: Link2,
    desc: `We are not responsible for any third-party website content, privacy policies, or practices. Use them at your own risk.`,
  },
  {
    id: "termination",
    title: "Termination",
    icon: AlertCircle,
    desc: `We may terminate or suspend access immediately without notice if you violate any terms. Upon termination, your rights to use the Service will cease immediately.`,
  },
  {
    id: "liability",
    title: "Limitation of Liability",
    icon: Gavel,
    desc: `Our liability is limited to the amount paid through the Service, or USD 100 if no purchase was made. We are not liable for indirect damages.`,
  },
  {
    id: "disclaimer",
    title: "“AS IS” and “AS AVAILABLE” Disclaimer",
    icon: Zap,
    desc: `The Service is provided “AS IS”. We make no guarantees regarding accuracy, availability, or performance, and we are not responsible for any harmful content.`,
  },
  {
    id: "governing",
    title: "Governing Law & Disputes",
    icon: Globe2,
    desc: `These terms are governed by the laws of Uttar Pradesh, India. Any disputes should first be resolved informally by contacting us.`,
  },
  {
    id: "eu",
    title: "For European Union Users",
    icon: Globe2,
    desc: `EU consumers will benefit from mandatory provisions of the law of their country of residence.`,
  },
  {
    id: "us",
    title: "United States Legal Compliance",
    icon: ShieldCheck,
    desc: `You confirm that you are not located in a country under US embargo and not listed on any US prohibited party lists.`,
  },
  {
    id: "severability",
    title: "Severability & Waiver",
    icon: Gavel,
    desc: `If any part of these terms is unenforceable, it will be adjusted and the rest will remain effective. Failure to enforce any right does not waive that right.`,
  },
  {
    id: "changes",
    title: "Changes to Terms",
    icon: FileText,
    desc: `We may update these Terms anytime. Material changes will be notified 30 days in advance. Continuing to use the Service means you accept the updated terms.`,
  },
  {
    id: "contact",
    title: "Contact Us",
    icon: Link2,
    desc: `If you have questions, contact us at: florettownfbgroup@gmail.com`,
  },
];

const TermsAndConditions = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          title="Terms & Conditions"
          subtitle="Please read these terms carefully before using our Service."
        />

        <div className="mt-10 rounded-2xl border border-gray-100 bg-white p-6 sm:p-8 shadow-sm">
          {terms.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.id} className="mb-8 last:mb-0">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center border border-emerald-100">
                    <Icon className="w-6 h-6 text-emerald-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-3 text-sm text-gray-600">{item.desc}</p>
              </div>
            );
          })}

          <p className="pt-4 text-sm text-gray-500">
            Last updated: May 09, 2025
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
